import React, { memo } from 'react';
import * as styles from './FindInStore.module.scss';
import useStoreTodayHours from './hooks/useStoreTodayHours';
import { getStatus, getStatusConfig } from './utils';
import useAvailability from './hooks/useAvailability';
import { useStoreContext } from './FindInStoreContext';
import useWasParms from '../../../../../Hooks/useWasParms';

const StoreCard = memo(function StoreCard({ store, selected, onSelect }) {
  const wasParms = useWasParms();
  const availability = useAvailability(store);
  const status = getStatus(availability, wasParms);
  const statusObj = getStatusConfig(status, styles);
  const { openTodayText, formattedHours } = useStoreTodayHours(store.operatingHours);
  const { selectedSku } = useStoreContext();
  const hasSku = !!selectedSku;

  return (
    <div
      className={selected ? `${styles.storeCard} ${styles.selected}` : styles.storeCard}
      onClick={() => onSelect(store)}
      tabIndex={0}
      role='button'
      aria-pressed={selected}
      onKeyDown={(e) => (e.key === 'Enter' ? onSelect(store) : undefined)}
    >
      <span>
        <input
          type='radio'
          checked={!!selected}
          onChange={() => onSelect(store)}
          className={styles.radioBtn}
          aria-label={`Select ${store.description}`}
        />
        <span></span>
      </span>
      <div className={styles.storeInfo}>
        <h3 className={`${styles.storeName} mb-1`}>Dillard&apos;s {store.description}</h3>
        <div className={`${styles.storeHours} mb-1`}>
          <span className={styles.openToday}>{openTodayText}</span>
          {formattedHours && <> • {formattedHours}</>}
        </div>
        <div className={`${styles.storeAddress} m-0`}>
          {store.metadata?.addr1}
          <br />
          {store.metadata?.city}, {store.metadata?.statename} {store.metadata?.zipcode}
        </div>
        {hasSku && availability && (
          <div className={`${styles.statusRow} mt-3`}>
            <span className={`${styles.icon} ${styles.stock} ${statusObj.className} mr-1`}>{statusObj.icon}</span>
            <span className={statusObj.className}>{statusObj.text}</span>
          </div>
        )}
      </div>
    </div>
  );
});

export default StoreCard;
